module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-42.3fa205f6.png";